import type { TFunction } from "i18next";
import { isApiError } from "../../../api/client.js";

export function mapTemplateManagementError(
  t: TFunction,
  error: unknown,
  unreachableMessage: string,
): string {
  if (isApiError(error)) {
    if (error.status === 0) return unreachableMessage;
    switch (error.code) {
      case "WHATSAPP_TEMPLATE_DUPLICATE":
        return t("whatsapp.templates.manage.errors.duplicate");
      case "WHATSAPP_TEMPLATE_UNSUPPORTED":
        return t("whatsapp.templates.manage.errors.unsupported");
      case "WHATSAPP_TEMPLATE_NOT_EDITABLE":
        return t("whatsapp.templates.manage.errors.notEditable");
      case "WHATSAPP_TEMPLATE_NOT_DELETABLE":
        return t("whatsapp.templates.manage.errors.notDeletable");
      case "WHATSAPP_TEMPLATE_INVALID_PHONE_NUMBER":
        return t("whatsapp.templates.manage.errors.invalidPhone");
      case "WHATSAPP_TEMPLATE_CREATE_OUTCOME_UNKNOWN":
        return t("whatsapp.templates.manage.errors.createOutcomeUnknown");
      case "WHATSAPP_NOT_CONNECTED":
        return t("whatsapp.templates.manage.errors.notConnected");
      case "WHATSAPP_PROVIDER_ERROR":
        return t("whatsapp.templates.manage.errors.provider");
      case "VALIDATION_FAILED":
        return t("whatsapp.templates.manage.errors.validation");
      case "FORBIDDEN":
        return t("whatsapp.templates.manage.errors.forbidden");
      case "PLATFORM_NOT_ENABLED":
        return t("whatsapp.templates.manage.errors.platformDisabled");
      default:
        return error.message || t("whatsapp.templates.manage.errors.generic");
    }
  }
  return unreachableMessage;
}
